module.exports = __webpack_public_path__ + "img/remove-watermarks.870127ac.svg";